export const SaleTypeMap: Record<string, string> = {
  "0": "BSPAir",
  "1": "Supplier",
  "2": "Voucher",
  "3": "CommVoucher",
};

/** Voucher and CommVoucher: no form of payment, so commission is adjusted on the original AR line. */
export const VOUCHER_SALE_TYPES: readonly number[] = [2, 3];
